import n from "../../_styles/common/light.js";
function y(o) {
  const {
    textColorBase: t,
    opacity1: c,
    opacity2: i,
    opacity3: p,
    opacity4: a,
    opacity5: e
  } = o;
  return {
    color: t,
    opacity1Depth: c,
    opacity2Depth: i,
    opacity3Depth: p,
    opacity4Depth: a,
    opacity5Depth: e
  };
}
const h = {
  name: "Icon",
  common: n,
  self: y
}, r = h;
export {
  r as default,
  y as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/icon/styles/light.js
// module id = 1651
// module chunks = 41